<div class="content-align" [dir]="data.dir">
    <app-form-by-key *ngIf="formReady" [formKey]="data.resource" [submission]="submission" [readOnly]="data.isView"
        [disableFields]="disableFields" [enableFormSubmit]="true" (onSubmit)="onSubmit($event)"
        (onCustomEvent)="onCustomEvent($event)" (onFormLoad)="onFormLoad()">
    </app-form-by-key>
</div>